import { render, staticRenderFns } from "./UsersInvitations.vue?vue&type=template&id=73880718&scoped=true&"
import script from "./UsersInvitations.vue?vue&type=script&lang=js&"
export * from "./UsersInvitations.vue?vue&type=script&lang=js&"
import style0 from "./UsersInvitations.vue?vue&type=style&index=0&id=73880718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73880718",
  null
  
)

export default component.exports